<template>
  <div class="big-number-card" :class="`big-number-card--${orientation}`">
    <div class="big-number-card__label">
      {{ label }}
    </div>
    <div class="big-number-card-value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BigNumberCard',
  props: {
    orientation: {
      type: String,
      required: false,
      default: 'vertical',
      validator: value => ['vertical', 'horizontal'].includes(value)
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: '-'
    }
  }
});
</script>

<style lang="scss">
@import '@/styles/partials/typography';

.big-number-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 2px;

  border-radius: 8px;
  border: 1px solid $color-line-border;
  background-color: $color-background-secondary;

  min-inline-size: 192px;
  min-block-size: 64px;

  padding: $spacing-2 $spacing-3;
}

.big-number-card--horizontal {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  min-inline-size: 156px;
  min-block-size: auto;
}

.big-number-card__label {
  @include typography('caption-bold');

  color: $color-text-placeholder;
}

.big-number-card-value {
  @include typography('heading-md-bold');

  color: $color-text-tertiary;
}
</style>
